import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

export enum FileExportType {
  STR = 0,
  DM4 = 1,
  DXF = 2
}

export enum DxfVersion {
  AutoCAD_R12 = 0,
  AutoCAD_2000 = 1,
  AutoCAD_2004 = 2,
  AutoCAD_2007 = 3,
  AutoCAD_2010 = 4,
  AutoCAD_2013 = 5,
  AutoCAD_2018 = 6
}

export interface ExportResult {
  fileTypes: FileExportType[];
  dxfVersion: DxfVersion;
}

@Component({
  selector: 'app-export-file-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './export-file-modal.component.html',
  styleUrls: ['./export-file-modal.component.scss']
})
export class ExportFileModalComponent implements OnDestroy {
  public onExport: Subject<ExportResult> = new Subject<ExportResult>();
  selectedFileTypes: FileExportType[] = [];
  selectedDxfVersion: DxfVersion = DxfVersion.AutoCAD_2000;
  FileExportType = FileExportType;

  dxfVersions = [
    { value: DxfVersion.AutoCAD_R12, label: 'AutoCAD R12' },
    { value: DxfVersion.AutoCAD_2000, label: 'AutoCAD 2000' },
    { value: DxfVersion.AutoCAD_2004, label: 'AutoCAD 2004' },
    { value: DxfVersion.AutoCAD_2007, label: 'AutoCAD 2007' },
    { value: DxfVersion.AutoCAD_2010, label: 'AutoCAD 2010' },
    { value: DxfVersion.AutoCAD_2013, label: 'AutoCAD 2013' },
    { value: DxfVersion.AutoCAD_2018, label: 'AutoCAD 2018+' },
  ];

  constructor(public bsModalRef: BsModalRef) {}

  ngOnDestroy(): void {
    this.onExport.complete();
  }

  toggleFileType(fileType: FileExportType): void {
    const index = this.selectedFileTypes.indexOf(fileType);
    if (index > -1) {
      this.selectedFileTypes.splice(index, 1);
    } else {
      this.selectedFileTypes.push(fileType);
    }
  }

  isSelected(fileType: FileExportType): boolean {
    return this.selectedFileTypes.includes(fileType);
  }

  isDxfSelected(): boolean {
    return this.selectedFileTypes.includes(FileExportType.DXF);
  }

  exportFiles(): void {
    if (this.selectedFileTypes.length > 0) {
      this.onExport.next({
        fileTypes: [...this.selectedFileTypes],
        dxfVersion: this.selectedDxfVersion
      });
      this.bsModalRef.hide();
    }
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
}
